import {
  FiTrendingDown,  // Liquidation
  FiDollarSign,     // Exchange Fee
  FiActivity,       // Basic DCA
} from 'react-icons/fi';

import {
  BsGraphUpArrow,   // DCA Historical
  BsArrowDownUp,    // DCA Position Sizing
  BsCurrencyExchange, // Crypto Conversion
} from 'react-icons/bs';

import {
  HiOutlineChartBar,  // P&L Calculator
} from 'react-icons/hi';

import {
  MdOutlineSavings,  // Staking Rewards
} from 'react-icons/md';

import {
  AiOutlineLineChart, // Holding Rewards
  AiOutlinePercentage, // Exchange Fee 100USD
} from 'react-icons/ai';

export const calculatorCategories = [
  {
    id: 'liquidation',
    title: 'Liquidation Calculator',
    guide:'https://docs.logiculus.com/getting-started/calculate-liquidation-price',
    description1: 'Estimates Liquidation Price for Leveraged Trades.',
    description: [
      ' This tool estimates the price at which your futures position would be liquidated, based on your entry price, leverage, and trade direction (long or short).It helps you manage risk and avoid losing your entire margin in leveraged trades.',
    ],
    icon: FiTrendingDown,
    color: 'from-red-500 to-orange-500',
    bgColor: 'bg-red-500/10',
    calculators: [
      {
        id: 'liquidation_calc',
        name: 'Position Liquidation',
        fields: [
          { name: 'exchange', type: 'select', label: 'Exchange', required: true, tooltip: 'Select the exchange where the trade is placed.'  },
          { name: 'symbol', type: 'text', label: 'Symbol', placeholder: 'BTC/USDT', required: true,tooltip: 'Select the symbol, like BTC.' },
          { name: 'entry_price', type: 'number', label: 'Entry Price', placeholder: '50000', required: true,tooltip: 'The price at which you entered the trade.' },
          { name: 'leverage', type: 'number', label: 'Leverage', placeholder: '10', required: true,tooltip: 'Your chosen leverage for this trade.'  },
          { name: 'side', type: 'select', label: 'Position Side', options: ['long', 'short'], required: true,tooltip: 'Choose if the position is Long (buy) or Short (sell).'  },
        ],
      },
    ],

  },
  {
    id: 'fees',
    title: 'Exchange Fee Calculator',
    guide:'https://docs.logiculus.com/getting-started/exchange-fee-calculator',
    description1: 'Calculates maker/taker fees per trade.',
    description: [
      ' This tool tells you exactly how much maker and taker fee you pay for trading a specific crypto on a selected exchange — based on a custom USD amount.Great for understanding your true trading costs before placing an order.',
    ],
    icon: FiDollarSign,
    color: 'from-yellow-500 to-amber-500',
    bgColor: 'bg-yellow-500/10',
    calculators: [
      {
        id: 'fee_calc',
        name: 'Trading Fees',
        fields: [
          { name: 'exchange', type: 'select', label: 'Exchange', required: true,tooltip: 'Select the exchange where the trade will occur.'  },
          { name: 'symbol', type: 'text', label: 'Symbol', placeholder: 'BTC', required: true,tooltip: 'Select the trading symbol.' },
          { name: 'volume_usd', type: 'number', label: 'Volume (USD)', placeholder: '10000', required: true,tooltip: 'Total trade volume in USD to calculate fees.' }
        ]
      }
    ]
  },
  {
    id: 'basic_dca',
    title: 'DCA Calculator',
    guide:'https://docs.logiculus.com/getting-started/calculate-dca-strategy',
    description1: 'Plans DCA levels for safer entries.',
    description: [
      ' This tool helps you plan a Dollar-Cost Averaging (DCA) strategy by showing where to place your buy orders as the price drops.Youll see your buy levels, how much crypto you’ll get at each, and your final average entry price — great for long-term accumulation and risk management.',
    ],
    icon: FiActivity,
    color: 'from-green-500 to-emerald-500',
    bgColor: 'bg-green-500/10',
    calculators: [
      {
        id: 'dca_basic',
        name: 'Basic DCA',
        fields: [
          { name: 'symbol', type: 'text', label: 'Symbol', placeholder: 'BTC', required: true,tooltip: 'Select the symbol' },
          { name: 'entry_price', type: 'number', label: 'Entry Price', placeholder: '110000', required: true, tooltip: 'Initial buy price for your DCA strategy.' },
          { name: 'num_orders', type: 'number', label: 'Number of Orders', placeholder: '5', required: true,tooltip: 'Total number of buy orders in your DCA plan.' },
          { name: 'price_drop_pct', type: 'number', label: 'Price Drop per Order (%)', placeholder: '2', required: true,tooltip: 'Percentage price drop after each order.' },
          { name: 'investment_per_order', type: 'number', label: 'Total Investment', placeholder: '1000', required: true,tooltip: 'Total investment amount across all DCA orders.' }
        ]
      }


    ]
  },
  // {
  //   id: 'dcah',
  //   title: 'DCA Historical Calculator',
  //   guide:'https://docs.logiculus.com/getting-started/calculate-historical-dca',
  //   description1: 'Tracks DCA returns using historical data',
  //   description: [
  //     ' This tool shows how much profit (or loss) you have made if you used a DCA (Dollar-Cost Averaging) strategy starting from a past date. It invests a fixed amount at regular intervals, includes exchange fees, and tells you your total returns and average buy price — based on real historical price data.'],
  //   icon: BsGraphUpArrow,
  //   color: 'from-indigo-500 to-blue-600',
  //   bgColor: 'bg-indigo-500/10',
  //   calculators: [
  //     {
  //       id: 'historical_dca',
  //       name: 'Historical DCA',
  //       fields: [
  //         { name: 'exchange', type: 'text', label: 'Exchange', placeholder: 'binance', required: true,tooltip: 'Select Exchange' },
  //         { name: 'symbol', type: 'text', label: 'Symbol', placeholder: 'BTC', required: true,tooltip: 'Crypto symbol you invested in historically.' },
  //         { name: 'start_date', type: 'date', defaultDate: '2024-01-01', minDate: '2023-12-31', label: 'Start Date', placeholder: '2024-12-31', disableFuture: true, required: true,tooltip: 'Date from which the DCA investment begins.' },
  //         { name: 'investment_per_interval', type: 'number', label: 'Investment per Interval', placeholder: '100', required: true,tooltip:"Investment per Interval",tooltip: 'Amount invested at each interval (e.g., every 30 days).' },
  //         { name: 'interval_days', type: 'number', label: 'Interval (Days)', placeholder: '30', required: true,tooltip: 'Number of days between each investment.' }
  //       ]
  //     }

  //   ]
  // },
  {
    id: 'dcap',
    title: 'DCA Position Sizing',
    guide:'https://docs.logiculus.com/getting-started/calculate-position-size',
    description1: 'Calculates investment needed to average down',
    description: [
      ' This tool tells you how much more you need to invest at the current price to bring your average buy price down to a specific target.Its perfect for planning smart DCA moves when youre holding a losing position and want to improve your average — with fees factored in!',
    ],
    icon: BsArrowDownUp,
    color: 'from-pink-500 to-fuchsia-600',
    bgColor: 'bg-pink-500/10',
    calculators: [
      {
        id: 'dca_position',
        name: 'DCA Position Sizing',
        fields: [
          { name: 'exchange', type: 'text', label: 'Exchange', placeholder: 'binance', required: true,tooltip: 'Exchange where the asset is held or traded.' },
          { name: 'symbol', type: 'text', label: 'Symbol', placeholder: 'BTC', required: true,tooltip: 'Symbol of the crypto asset.' },
          { name: 'initial_investment', type: 'number', label: 'Initial Investment', placeholder: '100', required: true,tooltip: 'Total amount you already invested.' },
          { name: 'initial_price', type: 'number', label: 'Initial Price', placeholder: '100', required: true,tooltip: 'Price at which the initial investment was made.' },
          { name: 'current_price', type: 'number', label: 'Current Price', placeholder: '90', required: true,tooltip: 'Current market price of the asset.' },
          { name: 'target_avg_price', type: 'number', label: 'Target Average Price', placeholder: '95', required: true,tooltip: 'Desired average entry price after new investment.' }
        ]
      }


    ]
  },
  {
    id: 'plcalc',
    title: 'Profit and Loss Calculator',
    guide:'https://docs.logiculus.com/getting-started/pl-calculate',
    description1: 'Calculates trade profit/loss with fees',
    description: [
      ' This tool calculates your total profit or loss from a trade, including exchange fees.You just enter how much you invested in USD, the buy and sell prices — and it tells you how much you gained or lost, both before and after fees',
    ],
    icon: HiOutlineChartBar,
    color: 'from-sky-500 to-cyan-600',
    bgColor: 'bg-sky-500/10',
    calculators: [
      {
        id: 'plc',
        name: 'Profit and Loss Calculator',
        fields: [
          { name: 'exchange', type: 'text', label: 'Exchange', placeholder: 'binance', required: true,tooltip: 'Exchange where the trade occurred.' },
          { name: 'symbol', type: 'text', label: 'Symbol', placeholder: 'BTC', required: true,tooltip: 'Symbol of the crypto you traded.' },
          { name: 'investment_usd', type: 'number', label: 'Investment (USD)', placeholder: '100', required: true, tooltip: 'Total amount invested in USD.' },
          { name: 'buy_price', type: 'number', label: 'Buy Price', placeholder: '100', required: true,tooltip: 'Price at which you bought the crypto.'  },
          { name: 'sell_price', type: 'number', label: 'Sell Price', placeholder: '90', required: true,tooltip: 'Price at which you sold the crypto.' }
        ]
      }



    ]
  },
  {
    id: 'crypto',
    title: 'Cryto Conversion Calculator',
    guide:'https://docs.logiculus.com/getting-started/crypto-convert',
    description1: 'Converts crypto using real-time prices',
    description: [
      '  This tool helps you convert one cryptocurrency to another using real-time prices from a selected exchange.Just enter the amount and the crypto pair (like BTC to ETH), and it shows you how much you’ll get — even if a direct trading pair isn’t available.',
    ],
    icon: BsCurrencyExchange,
    color: 'from-amber-500 to-lime-600',
    bgColor: 'bg-amber-500/10',
    calculators: [
      {
        id: 'cryp',
        name: 'Crypto Conversion Calculator',
        fields: [
          { name: 'exchange', type: 'text', label: 'Exchange', placeholder: 'binance', required: true,tooltip: 'Exchange used for price reference or conversion.' },
          { name: 'from_symbol', type: 'text', label: 'From Symbol', placeholder: 'BTC', required: true,tooltip: 'The cryptocurrency you want to convert from.' },
          { name: 'to_symbol', type: 'text', label: 'To Symbol', placeholder: 'ETH', required: true,tooltip: 'The cryptocurrency you want to convert to.' },
          { name: 'amount', type: 'number', label: 'Amount to Convert', placeholder: '1', required: true,tooltip: 'How much of the source crypto to convert.' }
        ]
      }
    ]
  },
  {
    id: 'stakingr',
    title: 'Staking Rewards Calculator',
    guide:'https://docs.logiculus.com/getting-started/calculate-staking-rewards',
    description1: 'Estimates staking rewards in crypto/USD',
    description: [
      '  This tool estimates how much you earn by staking your crypto over time — using real-time prices and your chosen APY (Annual Percentage Yield).Just enter the amount, APY, and duration, and it tells you your expected rewards in both crypto and USD.',
    ],
    icon: MdOutlineSavings,
    color: 'from-teal-500 to-green-600',
    bgColor: 'bg-teal-500/10',
    calculators: [
      {
        id: 'staking_rewards',
        name: 'Staking Rewards Calculator',
        fields: [
          { name: 'exchange', type: 'text', label: 'Exchange', placeholder: 'binance', required: true,tooltip: 'Exchange where staking is done.' },
          { name: 'symbol', type: 'text', label: 'Symbol', placeholder: 'BTC', required: true,tooltip: 'Cryptocurrency symbol being staked.' },
          { name: 'amount', type: 'number', label: 'Amount', placeholder: '1.9', required: true, tooltip: 'Total amount of crypto staked.' },
          { name: 'apy', type: 'number', label: 'APY (%)', placeholder: '1.5', required: true,tooltip: 'Annual Percentage Yield offered.' },
          { name: 'years', type: 'number', label: 'Duration (Years)', placeholder: '12.5', required: true,tooltip: 'Total duration for which staking is planned (in years).' }
        ]
      }
    ]
  },
  {
    id: 'holdingr',
    title: 'Holding Rewards Calculator',
    guide:'https://docs.logiculus.com/getting-started/calculate-holding-return',
    description1: 'Tracks unrealized crypto profit or loss.',
    description: [
      ' This tool tells you how much profit or loss you’ve made on your crypto holdings based on your entry price and the current market price.Just enter how much you bought and at what price — and it shows your gains or losses in both % and USD.',
    ],
    icon: AiOutlineLineChart,
    color: 'from-gray-600 to-gray-900',
    bgColor: 'bg-gray-600/10',
    calculators: [
      {
        id: 'holdingr',
        name: 'Holding Rewards Calculator',
        fields: [
          { name: 'exchange', type: 'text', label: 'Exchange', placeholder: 'binance', required: true,tooltip: 'Exchange where the crypto is held.' },
          { name: 'symbol', type: 'text', label: 'Symbol', placeholder: 'BTC', required: true,tooltip: 'Cryptocurrency symbol.' },
          { name: 'entry_price', type: 'number', label: 'Entry Price', placeholder: '105000', required: true,tooltip: 'Price at which you bought the crypto.' },
          { name: 'quantity', type: 'number', label: 'Quantity Held', placeholder: '1.25', required: true,tooltip: 'Amount of crypto currently held in your wallet.' }
        ]
      }
    ]
  }
  // {
  //   id: 'exchangeusd',
  //   title: 'Exchange Fee 100USD',
  //   guide:'https://docs.logiculus.com/getting-started/calculate-fees-across-exchanges-on-usd100',
  //   description1: 'Fee Breakdown for $100 Trade',
  //   description: [
  //     'This tool tells you how much profit or loss you’ve made on your crypto holdings based on your entry price and the current market price. Just enter how much you bought and at what price — and it shows your gains or losses in both % and USD.',
  //   ],
  //   icon: AiOutlinePercentage, // just reference, not JSX
  //   color: 'from-purple-500 to-indigo-500',
  //   bgColor: 'bg-purple-500/10',
  //   link: '/dashboard/exchange100usd', // add a route field
  // }
]